import * as React from 'react';

import type { FormatDistanceInWordsOptions } from 'common/helpers/timeHelpers';
import { formatDistanceInWordsStrict } from 'common/helpers/timeHelpers';

interface TimeAgoProps extends Partial<FormatDistanceInWordsOptions> {
  to: Date;
  from?: Date;
  updateInterval?: number;
  className?: string;
}

export default class TimeAgo extends React.PureComponent<TimeAgoProps> {
  static defaultProps = {
    updateInterval: 60000,
  };

  private updateTimer?: number;

  componentDidMount() {
    this.updateTimer = setInterval(() => this.forceUpdate(), this.props.updateInterval);
  }

  componentWillUnmount() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer);
    }
  }

  render() {
    const { to, from = new Date(), updateInterval, className, ...options } = this.props;
    return <time className={className}>{`${formatDistanceInWordsStrict(from, to, options)}`}</time>;
  }
}
